module.exports = __webpack_public_path__ + "img/carne_bio.830d83cd.png";